module.exports = __webpack_public_path__ + "static/media/goweb.31ad944a.png";